export default "__VITE_ASSET__r1M0ugCy__"